<template>
  <section class="get-in-touch">
    <h2>Join DIGU's Talent Pool Today!</h2>
    <button class="schedule-button" @click="goToTalentOnDemand">
      Get Started
    </button>
  </section>
</template>

<script>
export default {
  name: 'GetInTouch',
  methods: {
    goToTalentOnDemand() {
      this.$router
        .push({
          path: '/talents-on-demand',
          hash: '', // Ensures navigation to top of page
        })
        .then(() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        });
    },
  },
};
</script>

<style scoped>
.get-in-touch {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 4rem;
  margin-bottom: 4rem;
  padding: 40px 20px;
  /* background: linear-gradient(to right, #eef4fd, #ffffff); */
}

.get-in-touch h2 {
  font-size: 28px;
  font-weight: bold;
  color: #000;
  margin-bottom: 20px;
}

.schedule-button {
  background-color: #007ab2; /* Navy blue color */
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 20px;
  transition: background-color 0.3s ease-in-out, transform 0.2s ease-in-out;
}

.schedule-button:hover {
  background-color: #00aeff; /* Slightly darker navy blue */
  transform: scale(1.05);
}

.get-in-touch p {
  font-size: 16px;
  color: #003d64;
  margin: 0;
}
</style>
